import { ResourceHelperService } from "../resource-helper.service";

/**
 * A class that contains methods for interacting with the product settlement period service
 */
export class ProductSettlementPeriodService {
  private productSettlementPeriods: InterACT.Interfaces.IResource<InterACT.Interfaces.ProductSettlement.ProductSettlementPeriodsResponse>;

  constructor(private $resource: ng.resource.IResourceService, private resourceHelperService: ResourceHelperService) {
    this.productSettlementPeriods = $resource('api/product-settlement-periods/:periodId');
  }

  /**
   * A method that gets a speciffic page worth of settlement periods for a supplied query.
   * @param page the page number to retrieve
   * @param perPageCount the number of settlement periods to show per page
   * @param queryText a query to use to filter the dataset with
   */
  public getList(page: number, perPageCount: number, queryText: string) {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, queryText);
    return this.productSettlementPeriods.get(options).$promise;
  }
}